"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAbsenceBasedOnShift = exports.checkIfHasAbsenceBasedOnShifts = exports.getAbsenceTimestamps = void 0;
var moment_1 = __importDefault(require("moment"));
var getAbsenceTimestamps = function (absence) {
    var _a = __read(absence.absence_hours ? absence.absence_hours.split('-') : [], 2), startHour = _a[0], endHour = _a[1];
    var startTimestamp = absence.absence_hours ? "".concat(absence.from, " ").concat(startHour, ":00") : "".concat(absence.from, " 00:00:00");
    var endTimestamp = absence.absence_hours ? "".concat(absence.to, " ").concat(endHour, ":00") : "".concat(absence.to, " 23:59:59");
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
    };
};
exports.getAbsenceTimestamps = getAbsenceTimestamps;
var checkIfHasAbsenceBasedOnShifts = function (shiftDate, absences, employeeId, relevantStatuses, showUnpaidAbsences) {
    return absences.some(function (absence) {
        return (0, moment_1.default)(shiftDate).isBetween(absence.from, absence.to, 'days', '[]') &&
            absence.employee_id === String(employeeId) &&
            absence.count_only_days_with_shifts &&
            relevantStatuses.includes(absence.status) &&
            (absence.is_paid || showUnpaidAbsences);
    });
};
exports.checkIfHasAbsenceBasedOnShifts = checkIfHasAbsenceBasedOnShifts;
var getAbsenceBasedOnShift = function (shiftDate, absences, employeeId, relevantStatuses, showUnpaidAbsences) {
    return absences.find(function (absence) {
        return (0, moment_1.default)(shiftDate).isBetween(absence.from, absence.to, 'days', '[]') &&
            absence.employee_id === String(employeeId) &&
            absence.count_only_days_with_shifts &&
            relevantStatuses.includes(absence.status) &&
            (absence.is_paid || showUnpaidAbsences);
    });
};
exports.getAbsenceBasedOnShift = getAbsenceBasedOnShift;
